import Container from './all-card-container';

export default Container;
